import { Component, createRef } from 'react';
import { object, array, number, bool, node, oneOfType, func } from 'prop-types';

class AirtelMap extends Component {
  state = {
    currentCenter: null,
    initialCenter: null,
    isDragging: false,
    activeMarker: null,
    marker: false,
    markerInfo: null,
    showingInfoWindow: false,
    activeOrder: null,
    satellite: false
  }

  static propTypes = {
    center: object,
    clusters: array,
    google: object,
    styles: array,
    marker: object,
    orders: array,
    tooltipContent: oneOfType([node, func]),
    withLengend: bool,
    zoom: number
  }

  mapRef = createRef();
  infoWindowRef = createRef();

  handleClickCenter = () => {
    const { initialCenter } = this.state;

    this.setState({ currentCenter: initialCenter });
  }

  centerMoved = (mapProps, mapInstance) => {
    this.setState({
      currentCenter: {
        lat: mapInstance.center.lat(),
        lng: mapInstance.center.lng()
      }
    });
  }

  handleClickZoomIn = () => {
    const { map } = this.mapRef.current;

    map.setZoom(map.zoom + 1);
  }

  handleClickZoomOut = () => {
    const { map } = this.mapRef.current;

    map.setZoom(map.zoom - 1);
  }

  handleClickMapType = () => {
    const { satellite } = this.state;
    const { map } = this.mapRef.current;
    const toggleSatellite = !satellite;

    if (toggleSatellite) {
      map.setMapTypeId('satellite');
    } else {
      map.setMapTypeId('roadmap');
    }

    this.setState({ satellite: toggleSatellite });
  }

  handleMarkerClicked = (props, marker) => {

    this.setState({
      markerInfo: props,
      activeMarker: marker,
      showingInfoWindow: !this.state.showingInfoWindow
    });
  }

  handleMapClicked = () => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null,
        activeOrder: null
      });
    }
  }

  handleMarkerDragStart = (props, markerInstance) => {
    this.infoWindowRef.current.closeWindow();
    markerInstance.setOpacity(.4);
  }

  handleMarkerDragend = (props, markerInstance) => {
    const { marker } = this.state;
    const markerPosition = markerInstance.getPosition();

    markerInstance.setOpacity(1);

    marker.position.lat = markerPosition.lat();
    marker.position.lng = markerPosition.lng();

    this.setState({ marker: marker, activeMarker: markerInstance });
  }

  handleOrderClick = (orderProps) => {
    const { orderId } = orderProps;

    this.setState({
      activeOrder: orderId,
      showingInfoWindow: true
    });
  }

  handleOrderMouseHover = (orderProps, polylineInstance) => {
    polylineInstance.setOptions({ strokeWeight: 3 });
  }

  handleOrderMouseOut = (orderProps, polylineInstance) => {
    polylineInstance.setOptions({ strokeWeight: 2 });
  }
}

export default AirtelMap;



// WEBPACK FOOTER //
// ./src/uis/components/Map/AirtelMap.js